import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import moment from "moment";

import ExistingPlans from "./ExistingPlans";
import NutritionPlanChart from "./NutritionPlanChart";
import NutritionPlanCalendar from "./NutritionPlanCalendar";
import PdfGuidesCard from "./PdfGuidesCard";

const todayUtc = Number(moment().format("YYYYMMDD"));

const NutritionPlans = ({ nutritionPlans, activeUser, athlete, dailyStats }) => {
  const { t } = useTranslation("athlete-portal");
  const { units } = activeUser;
  const startingCalendarDay = activeUser.startingCalendarDay || 0;

  const [activePlan, setActivePlan] = useState({});

  useEffect(() => {
    const activeNutritionPlan = nutritionPlans.find(
      (plan) => plan.utcStartDate <= todayUtc && plan.utcEndDate >= todayUtc
    );

    const activePlanStats = activeNutritionPlan
      ? {
          id: activeNutritionPlan._id,
          startDate: activeNutritionPlan.utcStartDate,
          endDate: activeNutritionPlan.utcEndDate,
          nutrients: {
            proteins: activeNutritionPlan.proteins || 0,
            carbs: activeNutritionPlan.carbs || 0,
            fats: activeNutritionPlan.fats || 0,
            fibers: activeNutritionPlan.fibers || 0,
          },
          restDay: activeNutritionPlan.restDay
            ? { ...activeNutritionPlan.restDay }
            : null,
          notes: activeNutritionPlan.notes ? activeNutritionPlan.notes : null,
        }
      : {};

    setActivePlan(activePlanStats);
  }, [nutritionPlans]);

  const handleChangeActivePlan = (id) => {
    const planData = nutritionPlans.find((plan) => plan._id === id);

    setActivePlan({
      id: planData._id,
      startDate: planData.utcStartDate,
      endDate: planData.utcEndDate,
      nutrients: {
        proteins: planData.proteins || 0,
        carbs: planData.carbs || 0,
        fats: planData.fats || 0,
        fibers: planData.fibers || 0,
      },
      restDay: planData.restDay ? { ...planData.restDay } : null,
      notes: planData.notes ? planData.notes : null,
    });
  };

  // activePlan (state above) is a reduced projection for NutritionPlanChart
  // — it drops mealPlan entirely, so the PDF-conflict check needs the real
  // record back from the source list instead of widening that state shape.
  const activePlanRaw = nutritionPlans.find((plan) => plan._id === activePlan.id);

  return (
    <div>
      <div className="np-plans-layout">
        <ExistingPlans
          nutritionPlans={nutritionPlans}
          activePlanId={activePlan.id}
          handleChangeActivePlan={handleChangeActivePlan}
        />

        <div className="np-plans-side">
          {activePlan.id ? (
            <NutritionPlanChart planStats={activePlan} />
          ) : (
            <div className="np-plan-card np-plan-card--empty">
              <p className="np-plan-card__title">
                {t("nutritionPage.planChart.plan")}
              </p>
              <p className="p4">{t("nutritionPage.noDataToShow")}</p>
            </div>
          )}

          <PdfGuidesCard athlete={athlete} activePlan={activePlanRaw} />
        </div>
      </div>

      <NutritionPlanCalendar
        startingCalendarDay={startingCalendarDay}
        nutritionPlans={nutritionPlans}
        stats={dailyStats}
        units={units}
      />
    </div>
  );
};

export default NutritionPlans;
